export default function getHasSeenAlertNotificationKey(id: string) {
	return `hasSeenAlertNotification-${id}`;
}
